import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import {
  EntranceExamStudent,
  FisExamRegistration,
  FisExamRegistrationInput,
  FisExamStudent,
  FisFeeFilter,
  FisRegistrationFilter,
  HandlingFeeFilter,
} from '../types/exam';

export interface ExamListParams {
  page: number;
  pageSize: number;
  search?: string;
  branchId?: number;
  universityId?: number;
  intakeId?: number;
  counselorId?: number;
}

export const listEntranceExamStudents = async (
  params: ExamListParams & { handlingFee?: HandlingFeeFilter },
): Promise<PaginatedResponse<EntranceExamStudent>> => {
  const { data } = await apiClient.get('/exams/entrance', { params });
  return data;
};

export const listFisExamStudents = async (
  params: ExamListParams & { registration?: FisRegistrationFilter; fee?: FisFeeFilter },
): Promise<PaginatedResponse<FisExamStudent>> => {
  const { data } = await apiClient.get('/exams/fis', { params });
  return data;
};

export const saveFisExamRegistration = async (
  studentId: number,
  payload: FisExamRegistrationInput,
): Promise<FisExamRegistration> => {
  const { data } = await apiClient.put(`/exams/fis/${studentId}/registration`, payload);
  return data.data;
};
